/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum MATERIAL_ORDER_PRIORITY {
    AA_HIGH = '1',
    AA_MEDIUM = '2',
    AA_LOW = '3',
    UNKNOWN = '',
    P58_PRIORITY_0 = '0',
    P58_PRIORITY_1 = '1',
    P58_PRIORITY_2 = '2',
    P58_PRIORITY_3 = '3',
    P58_PRIORITY_4 = '4',
    P58_PRIORITY_5 = '5',
    P58_PRIORITY_6 = '6',
}
